<script setup>
import { useLayoutStore } from '@/stores/layout.js'
import { useAuthUserStore } from '@/stores/auth.js'
import ThemeToggle from '@/components/ui/ThemeToggle.vue';
import Logo from '@/components/ui/Logo.vue';
import AnalysisNotice from '@/components/ui/AnalysisNotice.vue';

import NavyButton from '@/volt/NavyButton.vue';

import { iconFieldPt } from '@/volt/legacyPt';
const layoutStore = useLayoutStore();
const authStore = useAuthUserStore();

</script>
<template>
    <header :class="layoutStore.minimisedSidebar ? 'xl:ps-12' : 'xl:ps-80'" class="sticky top-0 inset-x-0 flex flex-wrap md:justify-start md:flex-nowrap z-[48] w-full bg-white border-b border-surface-100 text-sm py-3.5 dark:bg-surface-900 dark:border-surface-700 dark:text-surface-300 transition-all duration-300 transform">
      <nav class="px-4 sm:px-6 flex basis-full items-center w-full mx-auto">
        <div class="me-3 xl:hidden">
          <NavyButton icon="pi pi-bars" text rounded class="text-surface-700 dark:text-surface-200" @click="layoutStore.toggleMobileSidebar" v-tooltip.bottom="'Open navigation'" />
        </div>
        <div class="me-5 xl:me-0 xl:hidden">
          <!-- Logo -->
          <Logo />
          <!-- End Logo -->
        </div>
    
        <div class="w-full flex items-center justify-end ms-auto md:justify-between gap-x-1 md:gap-x-3">
    
          <div class="hidden xl:block">
            <NavyButton :icon="layoutStore.minimisedSidebar === false ? 'lni lni-shift-left' : 'lni lni-shift-right'" class="pl-1 pr-1 hover:bg-surface-100 dark:hover:bg-surface-700" @click="layoutStore.toggleSidebarSize" v-tooltip.bottom="'Hide / show the sidebar'"/>
            
            <!-- Search Input -->
            
            <!-- End Search Input -->
          </div>
          <!-- <IconField :pt="iconFieldPt" class="flex-grow">
              <InputIcon class="pi pi-search" />
              <InputText v-model="value1" placeholder="Search" class="w-2/5" />
          </IconField> -->
    
          <!-- Whether the analysis dashboards read is behind the working pages. -->
          <AnalysisNotice class="hidden md:flex" />

          <div class="flex flex-row items-center justify-end gap-1">
            <ThemeToggle v-tooltip.bottom="'Change theme'" /> 
            <NavyButton v-if="authStore.getIsStandardUser === false" as="router-link" to="/select-company" class="text-sm" icon="pi pi-building" v-tooltip.bottom="'Select company'" /> 
            <NavyButton class="text-sm" icon="pi pi-sign-out" @click="authStore.logout()" v-tooltip.bottom="'Log out'" />
    
            <!-- Dropdown -->
            <!-- Profile Dropdown &darr; -->
            <!-- End Dropdown -->
          </div>
        </div>
      </nav>
    </header>
</template>
